export default {
  "site.name": "OOPBuy Spreadsheet",
  "site.tagline": "Der ultimative OOPBuy Guide für Deutschland 2026",
  "site.description": "OOPBuy Spreadsheet Deutschland 2026 – Der komplette Guide mit den besten Produkten, Verkäufern & Tipps. Spare Versandkosten und finde Top-Qualität.",
}